import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[appDireccion]'
})
export class DireccionDirective {
  private regex: RegExp = new RegExp(/^[A-Z0-9_.\-\/#Ñ ]*$/);  // Incluye espacio al final
  constructor(private el: ElementRef) {}
  @HostListener('input', ['$event'])
  onInput(): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let filteredValue = '';
    let prevChar = '';
    for (const char of input.value.toUpperCase()) {
      // Permitir espacio solo si el carácter anterior no es espacio y no es vacío (evita espacios iniciales y múltiples)
      if (char === ' ') {
        if (prevChar && prevChar !== ' ') {
          filteredValue += char;
        }
      } else if (this.regex.test(char) && !(this.isSpecialChar(char) && this.isSpecialChar(prevChar) && char === prevChar)) {
        filteredValue += char;
      }
      prevChar = char;
    }
    if (filteredValue !== input.value) {
      input.value = filteredValue;
      input.dispatchEvent(new Event('input'));
    }
  }
  private isSpecialChar(char: string): boolean {
    return ['_', '.', '-', '/', '#'].includes(char);
  }
}
